<template>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex mb-4 text-darker justify-content-evenly">
      <a href="#" class="text-secondary text-decoration-none">
        <i class="fas fa-search"></i> Szukaj
      </a>
      <a href="#" class="text-primary text-decoration-none">
        <i class="fas fa-sync"></i> Odśwież
      </a>
    </div>
    <hr>
    <div class="row">
      <div class="d-lg-flex my-2">
        <h5>
          <router-link :to="{ name: 'UserList' }" class="text-decoration-none fw-bold">
            LISTA UŻYTKOWNIKÓW
          </router-link>
          <i class="fa-solid fa-circle-arrow-right mx-3"></i>
        </h5>
        <h5 class="fw-bold">
          DODAJ UŻYTKOWNIKA
        </h5>
      </div>
    </div>
    <form @submit.prevent="createUser">
      <div class="mb-3">
        <label for="name" class="form-label">Imię</label>
        <input type="text" class="form-control" id="name" v-model="this.name">
      </div>
      <div class="mb-3">
        <label for="last-name" class="form-label">Nazwisko</label>
        <input type="text" class="form-control" id="last-name" v-model="this.lastName">
      </div>
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input type="email" class="form-control" id="email" v-model="this.email">
      </div>
      <div class="mb-3">
        <label for="password" class="form-label">Hasło</label>
        <input type="password" class="form-control" id="password" v-model="this.password">
      </div>
      <div class="mb-3">
        <label for="confirm-password" class="form-label">Potwierdź hasło</label>
        <input type="password" class="form-control" id="confirm-password" v-model="this.confirmPassword">
      </div>
      <button class="btn btn-primary">
        Zatwierdź
      </button>
    </form>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import axios from 'axios'
import Swal from 'sweetalert2'
export default {
  name: 'CreateUser',
  components: { Navbar },
  data () {
    return {
      roles: [],
      name: '',
      lastName: '',
      email: '',
      password: '',
      confirmPassword: ''
    }
  },
  methods: {
    async createUser () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const data = {
        name: this.name,
        lastName: this.lastName,
        email: this.email,
        password: this.password,
        confirmPassword: this.confirmPassword
      }
      try {
        await axios.post(`${process.env.VUE_APP_API_BASE_URL}User`, data, config)
        await Swal.fire('Dodano użytkownika', '', 'success')
      } catch (e) {
        console.log(e)
        await Swal.fire('Nie udało się dodać użytkownika', '', 'error')
      }
    }
  }
}
</script>

<style scoped>

</style>
